import React, { useEffect, useState } from 'react';
import { PackageCheck, Car, Package, X, Loader2 } from 'lucide-react';
import { carsysApi } from '../api/carsysApi';
import { useT } from '../context/LanguageContext';

const eur = (n) => (Number(n) || 0).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
const fmt = (d) => (d ? new Date(d).toLocaleDateString('nl-NL') : '');

const SECTIES = [
  { key: 'onderdelenVerkocht', label: 'Verkochte onderdelen zonder bon', icon: PackageCheck },
  { key: 'handelautos', label: "Verkochte handelauto's zonder bon", icon: Car },
  { key: 'onderdelenVoorraad', label: 'Onderdelen uit voorraad', icon: Package },
];

const toRegel = (key, it) => (key === 'handelautos'
  ? { type: 'Voertuig', code: it.kenteken || '', omschr: `${[it.merk, it.model].filter(Boolean).join(' ')} (${it.kenteken})`.trim(), aantal: 1, prijs: it.prijs || 0, markering: 'Klant', bronHandelautoId: it.id }
  : { type: 'Onderdeel', code: it.code || '', omschr: it.naam || 'Onderdeel', aantal: 1, prijs: it.prijs || 0, markering: 'Klant', bronOnderdeelId: it.id });

export default function VerkoopBronPicker({ regels, onPick, onClose }) {
  const { t } = useT();
  const [data, setData] = useState(null);
  const [tab, setTab] = useState('onderdelenVerkocht');
  const [q, setQ] = useState('');
  useEffect(() => { carsysApi.getVerkoopBronnen().then(setData).catch(() => setData({})); }, []);

  const inBon = new Set((regels || []).flatMap(r => [r.bronOnderdeelId, r.bronHandelautoId]).filter(Boolean));
  const s = q.trim().toLowerCase();
  const items = ((data && data[tab]) || []).filter(it => !inBon.has(it.id)
    && (!s || `${it.naam || ''} ${it.code || ''} ${it.kenteken || ''} ${it.merk || ''} ${it.model || ''}`.toLowerCase().includes(s)));

  return (
    <div className="cs-modal-overlay" style={{ zIndex: 250 }} onClick={onClose}>
      <div className="cs-modal" style={{ width: 640 }} onClick={e => e.stopPropagation()} data-testid="verkoop-picker-modal">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
          <h3 style={{ margin: 0 }}>{t('Uit verkoop toevoegen')}</h3>
          <button className="cs-btn ghost" onClick={onClose} data-testid="verkoop-picker-close"><X size={14} /></button>
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 10 }}>
          {SECTIES.map(({ key, label, icon: Icon }) => (
            <button key={key} className={`cs-btn ${tab === key ? 'primary' : ''}`} style={{ fontSize: 12, padding: '5px 10px' }} onClick={() => setTab(key)} data-testid={`verkoop-picker-tab-${key}`}>
              <Icon size={13} /> {t(label)} {data && <span style={{ opacity: 0.75 }}>({(data[key] || []).filter(it => !inBon.has(it.id)).length})</span>}
            </button>
          ))}
        </div>
        <input className="cs-input" placeholder={t('Zoek op naam, code of kenteken…')} value={q} onChange={e => setQ(e.target.value)} data-testid="verkoop-picker-zoek" />
        <div style={{ maxHeight: 360, overflowY: 'auto', marginTop: 8 }}>
          {!data ? <div className="cs-empty"><Loader2 size={16} className="spin" /></div>
            : items.length === 0 ? <div className="cs-empty" data-testid="verkoop-picker-leeg">{t('Niets gevonden.')}</div>
            : (
              <table className="cs-table">
                <tbody>
                  {items.map(it => (
                    <tr key={it.id} style={{ cursor: 'pointer' }} onClick={() => { onPick(toRegel(tab, it), tab); onClose(); }} data-testid={`verkoop-picker-item-${it.id}`}>
                      <td style={{ fontWeight: 600 }}>{tab === 'handelautos' ? `${it.merk || ''} ${it.model || ''}` : it.naam}</td>
                      <td style={{ fontFamily: 'ui-monospace, monospace', fontSize: 12 }}>{tab === 'handelautos' ? it.kenteken : (it.code || it.kenteken || '')}</td>
                      <td style={{ fontSize: 12, color: 'var(--cs-text-muted)' }}>{it.verkochtOp ? `${t('Verkocht')} ${fmt(it.verkochtOp)}` : (it.status || '')}</td>
                      <td style={{ textAlign: 'right', fontWeight: 600 }}>{eur(it.prijs)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        </div>
        {tab === 'onderdelenVoorraad' && <div style={{ fontSize: 11.5, color: 'var(--cs-text-muted)', marginTop: 8 }}>{t('Een onderdeel uit voorraad wordt bij opslaan van de bon automatisch op "Verkocht" gezet.')}</div>}
      </div>
    </div>
  );
}
